export const styles = {
  listWrapper: {
    padding: '10px 30px',
    margin: 0,
  },
  description: {
    color: '#6D6D6D',
  },
  value: {
    fontWeight: 'bold',
    marginLeft: 10,
  },
}



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartsForMetric/ClientReferral/style.js